module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA40lEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzsSAIAKoGqoBrALKBevBp+P///9+/f4EkUMN/GABKm8UWGuWY22X6WqWb2ObmsJnPhmoAqoMiOTk4G6jBPiXBOEtg6up5cWW6TmUxnFZzoBogjkY4acWK3v69QA2WOVluuYqb9m4OLtYyz45CsmH6dL/CHXAN1V37IZ62z8uzypU8d/NqTJ25RlwIkwnMD0A5rCijOEYvX2/ajrVJHcEJZUG8ZpMJaJjc4lXe6OdaaFPW7D2j3dvUvwOhgUhEBw2DEgAA/Di+XugKDhoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/VG.png
// module id = 1298
// module chunks = 0